import { FC } from 'react'

interface props {
  colour: string | null
}

const ProductColourWall: FC<props> = ({ colour }) => {
  return (
    <>
      <div
        className="h-20 w-full rounded-sm md:aspect-productImage md:h-max md:rounded-none"
        style={{ backgroundColor: colour || 'white' }}
      ></div>
    </>
  )
}

export default ProductColourWall
